var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import ContractVersionUtils from './ContractVersionUtils';
class ContractV111Utils extends ContractVersionUtils {
    isModuleEnabled(moduleAddress) {
        const _super = Object.create(null, {
            contract: { get: () => super.contract }
        });
        return __awaiter(this, void 0, void 0, function* () {
            const modules = yield _super.contract.call('getModules', []);
            const selectedModules = modules.filter((module) => module.toLowerCase() === moduleAddress.toLowerCase());
            return selectedModules.length > 0;
        });
    }
}
export default ContractV111Utils;
//# sourceMappingURL=ContractV111Utils.js.map